<template>
  <svg
    :class="{
      'stroke-black dark:stroke-white': !active,
      'stroke-lush-green': active,
      'duration-300': true
    }"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 21C5.89543 21 5 20.1046 5 19V3H14L19 8V19C19 20.1046 18.1046 21 17 21H7Z"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M13 3V9H19" stroke-width="2" stroke-linejoin="round" />
    <path d="M9 13H15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9 17H15" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
<script setup>
defineProps(['active'])
</script>
